import { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Button } from '@aurecon-creative-technologies/styleguide'
import { ReactComponent as Logo } from '../assets/aurecon_logo_black.svg'
import { ReactComponent as AureconLogo } from '../assets/aurecon_logo_white.svg'
import { ABOUT_URL, JIRA_SUPPORT_URL } from '../config/config'
import { appInsights } from '../api/AppInsights'

import Style from '../styles/Login.module.sass'

interface IState {
  from: { pathname: string }
}

const Login: FC = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0()
  const location = useLocation()
  if (appInsights) appInsights.trackPageView({ name: 'Login' })

  if (isAuthenticated) return <Navigate to='/' />

  const handleButtonClick = (url: string) => {
    window.open(url)
  }

  const handleLogin = () => {
    const state = location.state as IState
    const targetUrl = state ? `/#${state.from.pathname}` : '/'

    loginWithRedirect({
      appState: { targetUrl },
      connection_scope: `offline_access`,
    })
  }

  return (
    <div className={`${Style.loginPage} login`}>
      <div className={Style.loginContainer}>
        <div className={Style.header}>
          <AureconLogo height={30} />
        </div>
        <div className={Style.content}>
          <h2>Welcome to</h2>
          <Logo className={Style.logo} />
          <p>Aurecon’s Smoke Testing.</p>
          <Button type='primary' cssClass='is-white' label='Login' onClick={handleLogin} />
        </div>
        <div className={Style.content} />
        <div className={Style.footer}>
          <Button type='text' cssClass='is-white' label='About' onClick={() => handleButtonClick(`${ABOUT_URL}`)} />
          <Button
            type='text'
            cssClass='is-white'
            label='Contact Us'
            onClick={() => handleButtonClick(`${JIRA_SUPPORT_URL}`)}
          />
        </div>
      </div>
    </div>
  )
}

export default Login
